/*jslint node: true, browser: true*/

"use strict";

var ko = require("pli/knockout");
var pliObservable = require("pli/forms-knockoutcontrols");

var entityRegistry = require("../entity-registry");
var selectionForm = require("../common-selectionform");
var viewModelInit = require("../document/viewModelInitExtensions");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Provision class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function Provision(factories) {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("Provision.ctor", factories); }

    // serializable properties
    this.guid = ko.observable(null);
    this.type = this.id = pliObservable(null, entityRegistry.provisionType.getPicklistBehaviourData(), "required", "picklist");
    this.applicable = ko.observable(false);
    this.numDays = pliObservable(null, "N0", "numeric");
    this.otherData = pliObservable();
    this.page = pliObservable();
    this.paragraph = pliObservable();
    this.comments = pliObservable();

    // non-serializable properties
    this.extras = function ProvisionExtras() { return; };
    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);

    this.extras.description = ko.computed(function () {
        var provisionItem = this.type.item();
        return provisionItem ? provisionItem[1] : "";
    }, this);
}


//---------------------------------------
Provision.prototype.initGridArray = function initProvisionGridArray(gridArray) {
    /// <summary>
    /// Add extra methods to the specified
    /// terms grid array (that has just
    /// been created).
    /// </summary>
    gridArray.copyItems = gridArray.factory.factories.secureAction(Provision.prototype._copyItems, gridArray);
    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
};


//-------------------------------------------
Provision.prototype.loadViewModel = function loadProvision(record) {
    if (window.console && window.console.group) { window.console.log("Provision.loadViewModel", record); }

    if (!record) { record = {}; }

    this.guid(record.guid || null);
    this.type.load(record.type);
    this.applicable(record.applicable || false);
    this.numDays.load(record.numDays);
    this.otherData.load(record.otherData);
    this.page.load(record.page);
    this.paragraph.load(record.paragraph);
    this.comments.load(record.comments);
};


//-------------------------------------------
Provision.prototype._copyItems = function copyProvisions() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and copy provision to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores provisions.
    /// </remarks>
    selectionForm.open({
        searchApi: "Geo-Document-SearchProvisions",
        multiSelect: true,
        text: {
            acceptButton: "Copy",
            iconClass: "sprite-copy-16",
            instructionHtml:
                "The search phrase can be a combination of file numbers, areas or lands.<br/>" +
                "To copy all provisions from a specific file to the current file:" +
                "<ol><li>Type in a search phrase</li><li>Click <strong>Search</strong></li><li>Press <strong>Ctrl+A</strong> to select all results</li><li>Click <strong>Copy</strong></li></ol>",
            title: "Copy Provisions",
            examples: [
                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
            ]
        },
        onAcceptedContext: this,
        onAccepted: function (newProvisionRows) {
            selectionForm.utils.pushRowItems({
                targetArray: this,
                records: newProvisionRows,
                rowMap: { type: 3, applicable: 4, numDays: 5, otherData: 6, page: 7, paragraph: 8, comments: 9 }
            });
        }
    });
};


//-------------------------------------------
Provision.prototype.itemComparer = null; // disable client-side sorting


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = viewModelInit.standardFactoryCreatorFor(
    Provision,
    "provisions"
);



//////////////////
// WEBPACK FOOTER
// ./app/document-provision/provisionViewModel.js
// module id = 574
// module chunks = 49